import i18next from "i18next"

export const DEFAULT_CURRENCY_CODE = "SAR"

export const getCurrencyLabel = (currencyCode = DEFAULT_CURRENCY_CODE) => {
  const code = String(currencyCode || DEFAULT_CURRENCY_CODE).trim() || DEFAULT_CURRENCY_CODE
  if (code === "SAR" || code === "RS") {
    return i18next.t(code, { defaultValue: code })
  }
  return code
}

/** Country-based currency used on many menu detail/list screens. */
export const getCurrencyLabelByCountryCode = countryCode =>
  getCurrencyLabel(countryCode === "SA" ? "SAR" : "RS")

export const formatCurrencyAmount = (
  amount,
  currencyCode = DEFAULT_CURRENCY_CODE
) => {
  const value = Number(amount ?? 0)
  const formatted = Number.isFinite(value) ? value.toLocaleString() : "0"
  const label = getCurrencyLabel(currencyCode)
  const isArabic = ["sa", "ar"].includes(i18next.language)
  return isArabic ? `${formatted} ${label}` : `${label} ${formatted}`
}